'use strict';

var StrategyConditionDirective = function StrategyConditionDirective(angularHelper) {
  return {
    restrict: 'E',
    replace: true,
    controller: 'StrategyConditionController',
    template: require('../templates/strategy-condition.html'),
    scope: {
      firstRow: '=',
      condition: '=',
      changeSelectedRow: '=',
      activeEntityType: '=',
      flowType: '=',
      level: '='
    },
    link: function link($scope, element) {
      element.find('div.row').focusin(function () {
        $scope.changeSelectedRow($scope.condition, 'conditions');
        angularHelper.triggerApply($scope);
      });
    }
  };
};
StrategyConditionDirective.$inject = ['AngularHelper'];
module.exports = StrategyConditionDirective;